/**
 * Helper Plugin
 * This plugin provides globally available methods and properties
 * to help handle data, configuration and text operations.
 * This should be used in priority when accessing data
 * before looking for specifid store getters and mutations
 */

/* eslint-disable no-param-reassign, func-names */

export default function install(Vue) {
  const _vue = Vue;
  if (install.installed) return;
  install.installed = true;
  _vue.prototype.$creator = _vue.$creator = 'Nicolas Chesné'; // eslint-disable-line
  _vue.mixin({
    computed: {
      /**
       * Returns the current applied theme.
       * Can be different than the currentCllection in the Teaser Case
       */
      $themedContent() {
        return this.$content[this.$currentTheme];
      },
      $currentTheme() {
        return this.$store.state.theme;
      },
      $currentCollection() {
        return this.$getCollectionById(this.$route.params.collectionId);
      },
    },
  });
}
